// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2oPXF","col":"CardReaderDesc_col__QWq3C","label":"CardReaderDesc_label__3pO8h"};